export default __webpack_public_path__ + "static/media/typescript.f2a7250a.svg";